<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          type="ARMAZEM"
          :dense="dense"
          label="Armazém"
          required
          class="required rounded-tag-small"
          v-model="formData.armazem"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="CONTA_CONTABIL"
          label="Conta contábil"
          required
          class="required rounded-tag-small"
          v-model="formData.contaContabil"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
